<template>
    <button 
        class="btn" 
        :class="[
            `btn-${outline ? 'outline-' : ''}${type}`,
            size ? `btn-${size}` : null,
            {
                'btn-block': block
            },
        ]"
        :type="submit ? 'submit' : 'button'"
        >
        <slot />
    </button>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'link',
        },

        size: {
            type: String,
            default: null,
        },

        block: {
            type: Boolean,
            default: false,
        },

        outline: {
            type: Boolean,
            default: false,
        },

        submit: {
            type: Boolean,
            default: false,
        },
    },
}
</script>